function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "asset_per_mappa");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ASSET"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.19,
  cy: 10.79,
  r: 4.64
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.42,
  cy: 10.79,
  r: 4.64
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.45,
  cy: 15.23,
  r: 4.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.18,
  y: 21.38,
  width: 21.95,
  height: 28.47,
  rx: 9.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.55,40.6v-10a10,10,0,0,1,8.82-9.87,9.54,9.54,0,0,0-7.83-4.11H14.23a9.56,9.56,0,0,0-9.54,9.54v10a9.56,9.56,0,0,0,9.54,9.53h3.31l.42,0A9.83,9.83,0,0,1,16.55,40.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.77,16.65H38.46a9.53,9.53,0,0,0-7.8,4.07,9.94,9.94,0,0,1,9.11,9.89v10a9.89,9.89,0,0,1-1.43,5.11h3.43a9.56,9.56,0,0,0,9.54-9.53v-10A9.56,9.56,0,0,0,41.77,16.65Z"
}));

var SvgIcoPeople = function SvgIcoPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_people.fb30b383.svg";
export { ForwardRef as ReactComponent };